<!-- 我的文档分享-文档资料上传 -->
<template>
  <div class="container">
    <div class="title" style="text-align: center;">图片资料上传</div>
    <el-form ref="videoForm"
             class="formBox"
             size="mini"
             :model="form"
             :rules="videoRules"
             label-width="100px"
             label-position="left"
             style="width: 6rem; margin: 0 auto"
    >
      <el-form-item prop="VAttachmentName" style="width: 100%;" label="名称">
        <el-input placeholder="请输入" type="text" v-model="form.VAttachmentName" auto-complete="on" name="VAttachmentName"></el-input>
      </el-form-item>

      <el-form-item prop="author"  style="width: 100%;" label="拍摄者">
        <el-input placeholder="请输入" v-model="form.author" auto-complete="on" name="author"></el-input>
      </el-form-item>
      <el-form-item prop="Filmlocations"   style="width: 100%;" label="拍摄日期">
          <el-date-picker v-model="form.Filmlocations" format="yyyy年MM月dd日" value-format="yyyy年MM月dd日"   type="date" style="width: 100%;"  placeholder="请选择">
          </el-date-picker>

      </el-form-item>
      <el-form-item prop="place"   style="width: 100%;" label="拍摄地点">
        <el-input placeholder="请输入" v-model="form.place" auto-complete="on" name="place"></el-input>
      </el-form-item>
      <el-form-item prop="keyrord"   style="width: 100%;" label="关键词">
        <el-input placeholder="请输入" v-model="form.keyrord" auto-complete="on" name="keyrord">
        </el-input><i id="keywordtitle" class="el-icon-warning" style="font-size: xx-small;color: gainsboro">{{keywordtitle}}</i>
      </el-form-item>

      <el-form-item prop="categoryid" style="width: 100%;" label="学科分类">
        <el-tree ref="menuTree" :data="data"  v-model="form.categoryid" node-key="id" :props="defaultProps" @node-click="handleNodeClick" highlight-current />
      </el-form-item>

      <el-form-item  style="width: 100%;height: 9em;" label="简介">
        <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 5}" v-model="form.VAttachmentContent"></el-input>
      </el-form-item>

      <div class="title" style="text-align: center;">附件提交</div>
      <el-form-item  prop="oldRemotePath" style="width: 100%;" label="上传原图">
        <el-upload
          ref="uploadRef"
          accept=".png,.jpg,.jpeg,.jpeg,.tif"
          :action="imgUrlAction"
          list-type="picture-card"
          :auto-upload="true"
          :limit="1"
          :file-list="imgList"
          :on-change="picHandleChange"
          :before-remove="beforeremove"
          :before-upload="beforeupload"
          :on-success="handleAvatarSuccess">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>

    </el-form>


    <!-- 上传 -->
    <div class="author">
      <el-button @click="onUploadRes()" type="primary" style="margin: 0 auto;">上传</el-button>
      <el-button @click="onCancel()" type="primary" style="margin: 0 auto;">取消</el-button>
    </div>




  </div>
</template>

<script>
import {jump, getUser} from "../../../../untils/auth.js";
import Tiff from 'tiff.js'
export default {
  name:'updatePic',
  data() {
    return {
      parentNode:[],
      form: {
        VAttachmentName: '',
        VAttachmentType: '1',
        auditStatus : 0,
        imgSource : 1,
        author: '',
        Filmlocations: '',
        place: '',
        keyrord: '',
        IProductPublic: '1',
        categoryid :'' ,
        // 提交的文件
        VAttachmentId: '',
        VAttachmentContent: '',
        oldRemotePath: '',
        vattachmentRemotePath: '',

        // VIsFree: '',
        IPrice: 0,
      },
      videoRules: {
        VAttachmentName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        keyrord: [{ required: true, message: '关键词不能为空', trigger: 'blur' }],
        categoryid: [{ required: true, message: '分类不能为空', trigger: 'blur' }],
        oldRemotePath: [{ required: true, message: '上传图不能为空',trigger: 'blur' }],
        VAttachmentContent: [{ required: true, message: '简介不能为空', trigger: 'blur'}],
      },
      // 图片上传
      imgUrlAction: window.IPConfig.IP + '/uploadImageToDfs.do',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'text',
      },
      breadList:[],
      showPrice: false,
      // 气泡框
      visible: false,
      keywordtitle:'',
      baseUrl:'',
      imgList:[]
    }

  },
  created() {
    this.form.VAttachmentId = this.$route.query.VAttachmentId;

    this.axios.post(window.IPConfig.IP + "/tbConfig/getTBConfig.do?VKey=keywordtitle").then((res) => {
      if (res.status == 200) {
        if (res.data.status == 200) {
          if (res.data.obj.length) {
            this.keywordtitle =res.data.obj[0].remark
          }
        }
      }
    });

    this.axios.post(window.IPConfig.IP + "/tBAttachments/getById.do?VAttachmentId="+this.form.VAttachmentId).then(res => {
      this.baseUrl = res.data.url;
      var data = res.data.obj;
       this.form.VAttachmentName =data.VAttachmentName
       this.form.author =data.author
     /* if (data.Filmlocations !=null){
        const [year, month, day] = data.Filmlocations.split('-');
        console.log(111)
        this.form.Filmlocations =`${year}年${month}月${day}日`
      }*/
       this.form.Filmlocations =data.Filmlocations
       this.form.place =data.place
       this.form.keyrord =data.keyrord

      var categoryidArr =data.categoryid;
      var categoryidArrs= categoryidArr.split(",");
      this.form.categoryid = categoryidArrs[categoryidArrs.length-1];

      this.form.VAttachmentContent =data.VAttachmentContent
      this.form.oldRemotePath =data.oldRemotePath
      this.form.vattachmentRemotePath =data.VAttachmentRemotePath
      console.log(data.categoryid)

      // 学科分类
      this.getCategroy();


      this.imgList.push({url:this.form.vattachmentRemotePath});

      this.$refs.uploadRef.$children[1].$el.style.display = 'none'

    })

  },
  methods: {
    jump,

    formatDate(date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${year}年${month}月${day}日`;
    },

    picHandleChange(file, fileList) {
      // 判断是否是tif格式
      if(file.raw.type === 'image/tiff'){
        let fr = new FileReader();
        fr.onload = function (e){
          let image = new Tiff({buffer:e.target.result});
          file.url = image.toDataURL();
        }
        fr.readAsArrayBuffer(file.raw);
        this.$emit("changFile","fileList");
      }
      this.$emit("changeFile",fileList);

      this.$refs.uploadRef.$children[1].$el.style.display = 'none'
    },

    beforeupload (file) {
      let loading = this.$loading({
        lock: true, // 显示/隐藏--默认为false
        text: "正在上传文件中，请耐心等等......", //显示在加载图标下方的加载文案
        background: "rgba(0,0,0,0.8)", //遮罩层颜色
        spinner: "el-icon-loading", //自定义加载图标类名
      });
    },

    beforeremove(file){
      this.$refs.uploadRef.$children[1].$el.style.display = 'block'
      var ids = [];
      ids.push(this.form.VAttachmentId);
      this.axios.post(window.IPConfig.IP + '/tBAttachments/deleteById.do?ids='+ids.join(",")).then((response) => {
        if (response.status == 200) {
          if (response.data.status == 200) {
            console.log(response.data)
          }
        }
      })
    },
    // 封面上传
    handleAvatarSuccess(res, file) {
      this.$loading().close()

      if (res.status == 200) {
        console.log(file.response.obj.vattachmentRemotePath)
        this.form.VAttachmentId = file.response.obj.vattachmentId;
        this.form.oldRemotePath = file.response.obj.oldRemotePath;
        this.form.vattachmentRemotePath = file.response.obj.vattachmentRemotePath;
      }else{
        this.$message({
          type: 'error',
          center: true,
          message: res.msg
        });
        const { uploadFiles } = this.$refs.uploadRef
        if (uploadFiles && uploadFiles.length) {
          uploadFiles.splice(uploadFiles.length - 1, 1)
        }

        this.$refs.uploadRef.$children[1].$el.style.display = 'block'
      }

    },


    // 上传
    onUploadRes() {
      console.log(this.form);
      this.$refs.videoForm.validate(valid => {
        if (valid) {
          this.form.VSystemId = this.$store.state.user.VSystemId;
          this.form.createdBy = JSON.parse(getUser()).principal.VUserId;
          this.form.imgCopyright =JSON.parse(getUser()).principal.VUserId;
          console.log(this.form);
          this.axios.post(window.IPConfig.IP + '/tBAttachments/addImage.do', this.form).then((response) => {
            console.log(response)
            if (response.data.status == 200) {
              // _this.onUserInfo();
              this.$message({
                type: 'success',
                message: '更改成功'
              });
              // 跳转上传列表
              this.$router.push({path: '/education/personalcenter/mypicfile'});
            } else if (response.data.status == 601) {
              this.jump('/login')
            } else {
              this.$message({
                type: 'info',
                message: '已取消更改'
              })
            }
            this.disabled = true;
            this.text = '编辑信息'
          })
        }
      })
    },

    // 取消上传
    onCancel() {
      this.$router.push({
        path: '/education/personalcenter/mypicfile',
      })
    },


    getCategroy() {
      this.axios.post(window.IPConfig.IP + "/tBCategory/getTree3.do", {
        VSystemId: '2ef5ac97d1d259d06309b71838f4e766',
        VModulerId: 'fcface19b4ae482581d7a5a403e72331'
      }).then((res) => {
        this.data = res.data.obj || [];

        let targetNodeKey = this.form.categoryid;
        this.$nextTick(() => {
          //判断是否存在指定节点
          if (this.$refs.menuTree.getNode(targetNodeKey)) {
            //若存在指定节点，则设置当前节点为指定节点（用于高亮显示当前节点）
            this.$refs.menuTree.setCurrentKey(targetNodeKey)
            //展开指定节点
            this.$refs.menuTree.store.nodesMap[targetNodeKey].expanded = true;
            var selected = this.$refs.menuTree.getCurrentNode();
            if (this.$refs.menuTree.getNode(selected) && this.$refs.menuTree.getNode(selected).parent) {
              this.expandParents(this.$refs.menuTree.getNode(selected).parent)
            }
          } else {
            //若不存在指定节点，则设置当前节点为null（清除当前节点的高亮效果）
            this.$refs.menuTree.setCurrentKey()
          }
        })
      });
    },
// 展开所有祖宗节点
    expandParents(node) {
      node.expanded = true
      if (node.parent) {
        this.expandParents(node.parent)
      }
    },

    handleNodeClick() {
      let node = this.$refs.menuTree.getCurrentNode();
      console.log(node)
      this.form.categoryid = node.id;
    },



  }
}
</script>

<style lang="stylus" scoped>
:deep(.el-upload) {
  height: 100%;
}
:deep(.el-upload-dragger) {
  height: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.tip {
  color: red;
}
//遮罩层
.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(100, 100, 100, 0.5);
  color: #ffffff;
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    opacity: 1;
  }
  .el-icon {
    margin: 0 10px;
    &:hover {
      color: #70aeed;
    }
  }
}

.container {
  padding 0.3rem
  border: 0.01rem solid #ccc

}
.title {
  font-size: 0.26rem;
  margin-bottom: 30px;
  font-weight: 500;
}
.author{
  width: 100%;
  text-align: center;
}
// 弹出框协议内容
.argummentTitle{
  width: 100%;
  text-align: center;
  font-size: .3rem;
  font-weight: 700;
}
.okBtn{
  position: absolute;
  bottom: .1rem;
  right: .5rem;
}
//  .el-dialog__body{
//     height: 4rem;
//     overflow-y: scroll;
//  }
.argumentCon{
  text-indent: 2em;
  line-height: 2;
  height: 4rem;
  overflow-y: scroll;
}
.el-dialog{
  margin-top:0 !important;
}

.ApplyForm {
  width: 60%;
}
.ApplyForm .Apply_title {
  text-align: center;
  font-size: 0.24rem;
  font-weight: bold;
  margin: 0 0 0.3rem;
}
.ApplyBox .ApplyForm .el-upload--picture-card {
  width: 0.8rem;
  height: 0.8rem;
  line-height: 0.8rem;
}
.ApplyBox .ApplyForm .el-upload-list--picture-card .el-upload-list__item {
  width: 0.8rem;
  height: 0.8rem;
}


.el-input {
  display: inline-block;

  input {
    background-color: transparent;
    border: 0px;
    -webkit-appearance: none;
    border-radius: 0px;
    padding: 12px 5px 12px 15px;
    color: $light_gray;
    height: 47px;
    caret-color: $cursor;

    &:-webkit-autofill {
      box-shadow: 0 0 0px 1000px #f8f9fa inset !important;
      -webkit-text-fill-color: $cursor !important;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Personalcenter/components/my/updatePic.vue